import { patternTelInput } from '@helper/functions';

export default function InputNumber({
  name,
  title,
  required,
  placeholder,
  value,
  errors,
  touched,
  handleChange,
  disabled,
  handleBlur,
  height = null,
}) {
  return (
    <div className="flex flex-col items-start gap-2.5 w-full relative">
      <div className="flex flex-row items-center gap-1">
        <p className="text-text-normal text-base font-semibold">{title}</p>
        {required && <p className="requiredText">اجباری</p>}
      </div>
      <input
        onBlur={handleBlur}
        disabled={disabled}
        name={name}
        onChange={handleChange}
        value={value}
        type="tel"
        onInput={patternTelInput}
        className={`
            ${errors && touched ? 'border-error' : 'border-light-grey'}
            ${height ? height : 'h-[54px]'}
            disabled:bg-light-grey/50 disabled:text-text-normal border-[1px] rounded-lg py-3.5 px-4 w-full placeholder:text-text-normal/70 placeholder:font-light placeholder:text-sm text-text-hard text-base transition-all`}
        placeholder={placeholder}
      />
      {errors && touched && (
        <p className="absolute -bottom-6 max-sm:-bottom-5 text-xs max-sm:text-[10px] text-error">{errors}</p>
      )}
    </div>
  );
}
